import React, { useEffect } from "react";
import Layout from "./Layout";
import Welcome from "../components/Welcome";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMe } from "../features/authSlice";

const Home = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isError } = useSelector((state) => state.auth);

    useEffect(() => {
        dispatch(getMe());
    }, [dispatch]);

    //const loggedInUser = localStorage.getItem("login");
    //useEffect(() => {
    //    if (!loggedInUser) {
    //        navigate("/")
    //    }
    //}, [navigate]);

    const loggedInUser = localStorage.getItem("login");

    useEffect(() => {
        if (isError) {
            navigate("/");
        }
    }, [isError, navigate]);

    if (loggedInUser) {

        return (
            <Layout>
                <Welcome />
            </Layout>
        );

    }
};

export default Home;